export enum TimesheetTypes {
  POST_CLOCK_IN = 'POST_CLOCK_IN',
  POST_CLOCK_IN_CANCEL = 'POST_CLOCK_IN_CANCEL',
  POST_CLOCK_IN_SUCCESS = 'POST_CLOCK_IN_SUCCESS',

  POST_CLOCK_OUT = 'POST_CLOCK_OUT',
  POST_CLOCK_OUT_CANCEL = 'POST_CLOCK_OUT_CANCEL',
  POST_CLOCK_OUT_SUCCESS = 'POST_CLOCK_OUT_SUCCESS',

  GET_TIMESHEET_LOGS = 'GET_TIMESHEET_LOGS',
  GET_TIMESHEET_LOGS_CANCEL = 'GET_TIMESHEET_LOGS_CANCEL',
  GET_TIMESHEET_LOGS_SUCCESS = 'GET_TIMESHEET_LOGS_SUCCESS',

  File_Upload = '[FILE UPLOAD] File_Upload',
  Cancel_File_Upload = '[FILE UPLOAD] Cancel_File_Upload',
  File_Upload_Success = '[FILE UPLOAD] File_Upload_Success',
  File_Upload_Failed = '[FILE UPLOAD] File_Upload_Failed',
}
